export default __webpack_public_path__ + "static/media/user.69beb868.svg";